/* Maison Ydille : comportements maison au-dessus de Dawn. */
(function () {
  function lire(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function ecrire(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }

  /* Bouton d'achat collant sur mobile : apparaît quand le bouton principal sort de l'écran. */
  function initCollant() {
    document.querySelectorAll('[data-my-collant]').forEach(function (bar) {
      if (bar.dataset.ready) return; bar.dataset.ready = '1';
      var cible = document.getElementById(bar.dataset.target);
      if (!cible || !('IntersectionObserver' in window)) return;
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { bar.classList.toggle('is-on', !e.isIntersecting); });
      }).observe(cible);
      bar.querySelector('button').addEventListener('click', function () {
        var b = document.getElementById(bar.dataset.target); if (b && !b.disabled) b.click();
      });
      var prix = document.querySelector('#price-' + bar.dataset.section + ' .price-item--last, #price-' + bar.dataset.section + ' .price-item--regular');
      var maj = function () { var p = document.querySelector('#price-' + bar.dataset.section + ' .price__sale:not([style*="none"]) .price-item--sale, #price-' + bar.dataset.section + ' .price-item--regular'); if (p) bar.querySelector('[data-my-prix]').textContent = p.textContent.trim(); };
      maj();
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(maj, 50); });
    });
  }

  /* Pop-up de bienvenue : une seule fois, après un délai réglable. */
  function initPop() {
    var pop = document.querySelector('[data-my-pop]');
    if (!pop || window.Shopify && Shopify.designMode && !pop.dataset.preview) return;
    var fermer = function () { pop.classList.remove('is-on'); ecrire('my_pop_vu', '1'); };
    pop.querySelectorAll('[data-my-pop-fermer]').forEach(function (b) { b.addEventListener('click', fermer); });
    pop.addEventListener('click', function (e) { if (e.target === pop) fermer(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') fermer(); });
    if (pop.dataset.succes === '1') { pop.classList.add('is-on'); ecrire('my_pop_vu', '1'); return; }
    if (lire('my_pop_vu')) return;
    setTimeout(function () { if (!document.querySelector('cart-drawer.active')) { pop.classList.add('is-on'); ecrire('my_pop_vu', '1'); } }, (parseInt(pop.dataset.delai, 10) || 8) * 1000);
  }

  /* Quiz chien / chat. */
  function initQuiz() {
    document.querySelectorAll('[data-my-quiz]').forEach(function (q) {
      var animal = null;
      q.querySelectorAll('[data-animal]').forEach(function (b) {
        b.addEventListener('click', function () {
          animal = b.dataset.animal;
          q.querySelectorAll('[data-animal]').forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
          q.querySelector('[data-my-q2]').hidden = false;
        });
      });
      q.querySelectorAll('[data-besoin]').forEach(function (b) {
        b.addEventListener('click', function () {
          q.querySelectorAll('[data-besoin]').forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
          var r = q.querySelector('[data-reponse="' + b.dataset.besoin + '-' + animal + '"]') || q.querySelector('[data-reponse="' + b.dataset.besoin + '-tous"]');
          q.querySelector('.my-quiz__rep').innerHTML = r ? r.innerHTML : '';
        });
      });
    });
  }

  /* Rétractation : 1) « Renoncer au contrat ici » 2) formulaire 3) « Confirmer la rétractation ». */
  function initRetract() {
    var b = document.querySelector('[data-my-renoncer]');
    if (!b) return;
    b.addEventListener('click', function () { document.querySelector('.my-retract__etape2').hidden = false; b.hidden = true; });
  }

  /* Vente additionnelle dans le tiroir panier : ajout sans quitter la page. */
  document.addEventListener('click', function (e) {
    var bt = e.target.closest('[data-my-upsell-id]');
    if (!bt) return;
    e.preventDefault();
    var drawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: parseInt(bt.dataset.myUpsellId, 10), quantity: 1 }] };
    if (drawer && drawer.getSectionsToRender) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    bt.disabled = true;
    fetch((window.routes && routes.cart_add_url ? routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (state) {
      if (drawer && state.sections) { drawer.renderContents(state); } else { window.location.href = (window.routes && routes.cart_url) || '/cart'; }
    }).catch(function () { window.location.href = '/cart'; });
  });

  /* Date de livraison estimée : 7 à 12 jours ouvrés (lundi à vendredi, jours fériés exclus). */
  var FERIES = ['2026-11-11','2026-12-25','2027-01-01','2027-03-29','2027-05-01','2027-05-06','2027-05-08','2027-05-17','2027-07-14','2027-08-15','2027-11-01','2027-11-11','2027-12-25'];
  function plusOuvres(d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); var j = d.getDay(), iso = d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2); if (j !== 0 && j !== 6 && FERIES.indexOf(iso) < 0) n--; } return d; }
  function joli(d) { try { return d.toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' }); } catch (e) { return d.getDate() + '/' + (d.getMonth() + 1); } }
  function initLivraison() {
    document.querySelectorAll('[data-my-livraison]').forEach(function (el) { var a = new Date(); el.textContent = 'chez vous entre le ' + joli(plusOuvres(a, 7)) + ' et le ' + joli(plusOuvres(a, 12)); });
  }

  function init() { initCollant(); initPop(); initQuiz(); initRetract(); initLivraison(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

/* Galerie de fiche produit (04/11) : glissé en boucle et points de position sur téléphone */
(function () {
  function init(viewer) {
    var liste = viewer.querySelector('.product__media-list');
    if (!liste || viewer.dataset.myBoucle) return;
    viewer.dataset.myBoucle = '1';
    var items = Array.prototype.filter.call(liste.children, function (li) { return li.offsetParent !== null || true; });
    if (items.length < 2) return;
    var points = document.createElement('div');
    points.className = 'my-points';
    items.forEach(function (_, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Photo ' + (i + 1) + ' sur ' + items.length);
      b.addEventListener('click', function () { aller(i); });
      points.appendChild(b);
    });
    viewer.after(points);
    function index() { return Math.round(liste.scrollLeft / Math.max(1, items[0].offsetWidth)); }
    function aller(i) { liste.scrollTo({ left: items[(i + items.length) % items.length].offsetLeft - items[0].offsetLeft, behavior: 'smooth' }); }
    function maj() { var n = index(); Array.prototype.forEach.call(points.children, function (b, i) { b.setAttribute('aria-current', i === n ? 'true' : 'false'); }); }
    liste.addEventListener('scroll', function () { window.requestAnimationFrame(maj); }, { passive: true });
    maj();
    // boucle : au bout, un glissé de plus ramène à l'autre extrémité
    var x0 = null, debut = 0;
    liste.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; debut = index(); }, { passive: true });
    liste.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (dx < -40 && debut === items.length - 1) aller(0);
      else if (dx > 40 && debut === 0) aller(items.length - 1);
    }, { passive: true });
    // flèches : boucle aussi
    var suiv = viewer.querySelector('.slider-button--next'), prec = viewer.querySelector('.slider-button--prev');
    if (suiv) suiv.addEventListener('click', function (e) { if (index() === items.length - 1) { e.stopImmediatePropagation(); aller(0); } }, true);
    [suiv, prec].forEach(function (b) {
      if (!b) return;
      b.removeAttribute('disabled');
      new MutationObserver(function () { if (b.hasAttribute('disabled')) b.removeAttribute('disabled'); }).observe(b, { attributes: true, attributeFilter: ['disabled'] });
    });
    if (prec) prec.addEventListener('click', function (e) { if (index() === 0) { e.stopImmediatePropagation(); aller(items.length - 1); } }, true);
  }
  function tout() { document.querySelectorAll('[id^="GalleryViewer-"]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tout); else tout();
})();
